module.exports = "<template>\nAPI Is down. Site is temporarily unavailable\n</template>";